import { compressWhitespace } from 'wanderu-utils';

import { CreateAccountValidationError } from './Errors';
import {
    LOCAL_STORAGE_KEY,
} from './constants';

const USERINFO_FIELDS = [
    'firstName',
    'lastName',
    'street',
    'street2',
    'country',
    'city',
    'stateProvince',
    'postalCode',
    'phone',
    'email',
];

function checkAccountInfoValid({
    email, password, firstName, lastName,
}) {
    if (!password || password.length < 6) {
        throw new CreateAccountValidationError();
    }
    if (!firstName) {
        throw new CreateAccountValidationError();
    }
    if (!lastName) {
        throw new CreateAccountValidationError();
    }
    if (!email || !email.includes('@', 1)) {
        throw new CreateAccountValidationError();
    }
}

async function wait(ms) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}

function parseFacebookResponse(facebookResponse) {
    return {
        firstName: facebookResponse.first_name,
        lastName: facebookResponse.last_name,
        email: facebookResponse.email,
    };
}

function formatUserInfo(rawUserInfo) {
    const {
        points,
        referral,
        firstName,
        lastName,
        email,
        ...billingAddress
    } = rawUserInfo;

    return {
        userInfo: {
            firstName,
            lastName,
            email,
            billingAddress,
        },
        loyaltyInfo: {
            points,
            referral,
        },
    };
}

function removeWhitespace(userInfo) {
    return Object.entries(userInfo).reduce((data, [key, value]) => {
        return {
            ...data,
            [key]: compressWhitespace(value),
        };
    }, {});
}

function filterWhitelistedInfo(userInfo) {
    return USERINFO_FIELDS.reduce((userInfoFields, fieldName) => {
        if (userInfo[fieldName] !== undefined) {
            return {
                ...userInfoFields,
                [fieldName]: userInfo[fieldName],
            };
        }

        return userInfoFields;
    }, {});
}

function formatUserInfoForPost(rawUserInfo = {}) {
    const whitelistedUserInfo = filterWhitelistedInfo(rawUserInfo);

    return removeWhitespace(whitelistedUserInfo);
}

function clearLocalStorageCredentials() {
    window.localStorage.removeItem(LOCAL_STORAGE_KEY);
}

export {
    checkAccountInfoValid,
    clearLocalStorageCredentials,
    formatUserInfo,
    formatUserInfoForPost,
    parseFacebookResponse,
    wait,
};
